import { getAll, destroy, printLabels } from "@/api/product";
const defaultState  = () => {
  return {
    product:{
      id: null,
      name: null,
      terms: []
    },
    list: [],
    loading: false,
    search: null,
    reference: null,
    pageSize: 10,
    currentPage: 1,
    totalRows: 0,
  }
}
export default {
  namespaced: true,
  state: defaultState(),
  getters:{
    all:       state => state.list,
    search:    state => state.search,
    reference: state => state.reference,
    loading:   state => state.loading,
    pageSize:  state => state.pageSize,
    totalRows: state => state.totalRows,
  },
  mutations:{
    RESET_RODUCT:(state) => {
      Object.assign(state, defaultState())
    },
    SET_TERMS: (state, connect) => {
      let index = state.product.terms.findIndex(element => element.title === connect.title)
      if (index != -1) {
        state.product.terms[index] = connect
        return
      }
      state.product.terms.push(connect)
    },
    SET_LIST(state, payload){
      state.list = []
      state.totalRows = payload.total
      payload.data.forEach((element) => {
        state.list.push({
          id: element.id,
          code: element.codigo,
          reference: element.referencia,
          manufacturer_reference: element.manufacturer_reference,
          description: element.descripcion,
          category: element.category.descripcion,
          type: element.type.descripcion,
          coste: element.costo,
          urlPath: element.url_path,
          used: element.usado,
          salePrice: element.precio_venta,
          finalPrice: element.precio_venta,
          variations: element.variations,
        });
      });
    },
    SET_LOADING(state, payload){
      state.loading = payload
    },
    SET_CURRENT_PAGE(state, payload){
      state.currentPage = payload
    },
    SET_SEARCH(state, payload){
      state.search = payload
    },
    SET_REFERENCE(state, payload){
      state.reference = payload
    }
  },
  actions:{
    async getAllAction({state, commit}, payload){
      try {
        commit('SET_LOADING', true)
        if (typeof payload == "undefined") {
          if (state.search != null) {
            commit('SET_CURRENT_PAGE', 1)
          }
          if (state.reference != null) {
            commit('SET_CURRENT_PAGE', 1)
          }
        } else {
          commit('SET_CURRENT_PAGE', payload)
        }
        if (state.reference === ''){
          commit('SET_REFERENCE', null)
        }
        if (state.search === ''){
          commit('SET_SEARCH', null)
        }
        let data = await getAll(state.pageSize, state.currentPage, state.search, state.reference)
        commit('SET_LIST', data.data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        console.error(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al listar productos.'}, {root: true})
      }
    },
    async deleteAction({commit, dispatch}, payload){
      try {
        let { data } = await destroy(payload)
        if (data.code == 200) {
          dispatch('getAllAction')
          return commit('SET_RESPONSE', {type: 'success', msg: 'Producto eliminado.'}, {root: true})
        }else if (data.code = 401) {
          return commit('SET_RESPONSE', {type: 'error', msg: data.msg}, {root: true})
        }
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al eliminar producto.'}, {root: true})
      } catch (error) {
        console.error(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al eliminar producto.'}, {root: true})
      }
    },
    async printLabelsAction({commit, dispatch}, payload){
      try {
        let { data } = await printLabels(payload)
        downloadFile(data, 'Labels')
      } catch (error) {
        console.error(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al imprimir labels.'}, {root: true})
      }
    }
  }
}

function downloadFile(response, filename) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([response], { type: "application/pdf" });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  link.href = data;
  link.download = filename + ".pdf";
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}